module.exports = __webpack_public_path__ + "static/media/7-1.1bf66b36.mp3";